/**
 * コンテンツ表示にスジが入る問題への対応
 * - drawImageで転写すると画像に「スジ」がはいるが、fillStyleのcreatePattern()とfillRectの組み合わせで解消される
 * @param {*} img 元イメージ
 * @param {*} canvas 転写先キャンバス
 */
export const transcribeImageToCanvas = (img, canvas) => {
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  let ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
};

/**
 * スクランブル解除
 * @param {*} canvas スクランブルキャンバス ※入出力を兼ねている：別のキャンバスへ転写して解除しながら描き戻す
 * @param {*} scrambleTable スクランブル配置番号リスト
 * @param {*} scrambleWidth スクランブル分割数：横
 * @param {*} scrambleHeight スクランブル分割数：縦
 * @param {*} resolution スクランブルサイズ最小単位
 */
export const unscrambling = (
  canvas,
  scrambleTable,
  scrambleWidth,
  scrambleHeight,
  resolution
) => {
  const transferCanvas = document.createElement("canvas");
  const draw_context = canvas.getContext("2d");
  let copy_canvas = transferCanvas;
  let copy_canvas_context = copy_canvas.getContext("2d");
  copy_canvas.width = canvas.width;
  copy_canvas.height = canvas.height;
  copy_canvas_context.drawImage(canvas, 0, 0);

  const block_w =
    Math.floor(Math.floor(canvas.width / scrambleWidth) / resolution) *
    resolution;
  const block_h =
    Math.floor(Math.floor(canvas.height / scrambleHeight) / resolution) *
    resolution;

  let draw_x, draw_y, copy_x, copy_y;
  let tableValue;
  let tableCount = scrambleTable.length;
  let i = 0;
  for (i; i < tableCount; i++) {
    draw_x = i % scrambleWidth;
    draw_y = Math.floor(i / scrambleWidth);
    draw_x *= block_w;
    draw_y *= block_h;

    tableValue = scrambleTable[i];
    copy_x = tableValue % scrambleWidth;
    copy_y = Math.floor(tableValue / scrambleWidth);
    copy_x *= block_w;
    copy_y *= block_h;

    draw_context.clearRect(draw_x, draw_y, block_w, block_h);
    draw_context.drawImage(
      copy_canvas,
      copy_x,
      copy_y,
      block_w,
      block_h,
      draw_x,
      draw_y,
      block_w,
      block_h
    );
  }

  copy_canvas_context.clearRect(0, 0, copy_canvas.width, copy_canvas.height);
  copy_canvas.width = 0;
  copy_canvas.height = 0;
  copy_canvas_context = null;
  copy_canvas = null;
};

/**
 * スクランブル解除実行
 */
export const doUnscramble = async (
  scrambleTable,
  scrambleWidth,
  scrambleHeight,
  resolution,
  img,
  canvas
) => {
  // 元イメージをキャンバスへ転写
  transcribeImageToCanvas(img, canvas);

  // スクランブル解除
  unscrambling(
    canvas,
    scrambleTable,
    scrambleWidth,
    scrambleHeight,
    resolution
  );
};
